import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _BuildingTimer;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@instructure/ui-text';
import { jsx } from '@instructure/emotion';
import t from '@instructure/quiz-i18n/es/format-message';
import { Setting } from '../Setting';
import { HOUR_IN_SECONDS, TimeUnitsInput } from '@instructure/quiz-core';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { withStyleOverrides } from '@instructure/quiz-common';
var HOURS_LIMIT = 168;
var LIMIT_IN_SECONDS = HOURS_LIMIT * HOUR_IN_SECONDS;
export var BuildingTimer = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_BuildingTimer = /*#__PURE__*/function (_Component) {
  function BuildingTimer() {
    var _this;
    _classCallCheck(this, BuildingTimer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, BuildingTimer, [].concat(args));
    _defineProperty(_this, "state", {
      errors: {
        hours: null,
        minutes: null
      }
    });
    _defineProperty(_this, "toggleHasTimeLimit", function (event, changeCompleteCb) {
      var _this$props = _this.props,
        setQuizHasTimeLimit = _this$props.setQuizHasTimeLimit,
        activeQuizId = _this$props.activeQuizId;
      var value = event.target.checked;
      setQuizHasTimeLimit(activeQuizId, value, changeCompleteCb);
      _this.setState({
        errors: {
          minutes: null,
          hours: null
        }
      });
    });
    _defineProperty(_this, "setNewLimit", function (changeCompleteCb) {
      return function (limitInSeconds) {
        var _this$props2 = _this.props,
          setSessionTimeLimitInSecondsApi = _this$props2.setSessionTimeLimitInSecondsApi,
          setSessionTimeLimitInSecondsUi = _this$props2.setSessionTimeLimitInSecondsUi,
          activeQuizId = _this$props2.activeQuizId;
        setSessionTimeLimitInSecondsUi(activeQuizId, limitInSeconds);
        // TODO: debounce these updates
        setSessionTimeLimitInSecondsApi(activeQuizId, limitInSeconds, changeCompleteCb);
      };
    });
    _defineProperty(_this, "onReset", function (current, previous) {
      _this.props.screenreaderNotification(t('The value has been updated to the allowed number'), 'polite');
    });
    return _this;
  }
  _inherits(BuildingTimer, _Component);
  return _createClass(BuildingTimer, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var hasTimeLimit = this.props.hasTimeLimit;
      return jsx(Setting, {
        automationData: "sdk-timeLimit-toggle",
        isChecked: hasTimeLimit,
        label: t('Time limit'),
        onChange: this.toggleHasTimeLimit,
        showMore: hasTimeLimit
      }, function (changeCompleteCb) {
        return jsx("div", {
          css: _this2.props.styles.wrapper
        }, jsx("div", {
          css: _this2.props.styles.inputsWrapper
        }, jsx(TimeUnitsInput, {
          onChange: _this2.setNewLimit(changeCompleteCb),
          onReset: _this2.onReset,
          timeInSeconds: _this2.props.sessionTimeLimitInSeconds,
          maxTimeInSeconds: LIMIT_IN_SECONDS,
          hoursLabel: jsx(Text, {
            weight: "light",
            color: "secondary",
            size: "small"
          }, t('Hours')),
          hoursDataAutomation: "sdk-timeLimit-hours",
          minutesLabel: jsx(Text, {
            weight: "light",
            color: "secondary",
            size: "small"
          }, t('Minutes')),
          minutesDataAutomation: "sdk-timeLimit-minutes",
          inputWidth: "5.5rem",
          description: t('Time limit')
        })), jsx("div", {
          css: _this2.props.styles.timeInfo
        }, jsx(Text, {
          weight: "light",
          color: "secondary",
          size: "small"
        }, t('Set to 0 for no time limit'))));
      });
    }
  }]);
}(Component), _defineProperty(_BuildingTimer, "displayName", 'BuildingTimer'), _defineProperty(_BuildingTimer, "componentId", "Quizzes".concat(_BuildingTimer.displayName)), _defineProperty(_BuildingTimer, "propTypes", {
  setQuizHasTimeLimit: PropTypes.func.isRequired,
  setSessionTimeLimitInSecondsUi: PropTypes.func.isRequired,
  setSessionTimeLimitInSecondsApi: PropTypes.func.isRequired,
  sessionTimeLimitInSeconds: PropTypes.number,
  hasTimeLimit: PropTypes.bool.isRequired,
  activeQuizId: PropTypes.string.isRequired,
  styles: PropTypes.object,
  screenreaderNotification: PropTypes.func.isRequired
}), _defineProperty(_BuildingTimer, "defaultProps", {
  sessionTimeLimitInSeconds: 0
}), _BuildingTimer)) || _class);
export default BuildingTimer;